(() => {
  const ready = () => {
    document.querySelectorAll('[data-oc-sort]').forEach(select => {
      const grid = select.closest('[data-oc-series]')?.querySelector('[data-oc-sort-grid]');
      if (!grid) return;
      const cards = Array.from(grid.children); const original = new Map(cards.map((c,i) => [c,i]));
      select.addEventListener('change', () => {
        const ordered = [...cards].sort((a,b) => {
          if (select.value === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
          if (select.value === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
          if (select.value === 'name') return a.dataset.title.localeCompare(b.dataset.title);
          return original.get(a) - original.get(b);
        });
        ordered.forEach(card => grid.append(card));
      });
    });
    document.querySelectorAll('[data-oc-nav-disclosure]').forEach(details => {
      const summary = details.querySelector('summary');
      const sync = () => summary.setAttribute('aria-expanded', String(details.open));
      summary.addEventListener('click', event => {
        event.preventDefault();
        const nextOpen = !details.open;
        document.querySelectorAll('[data-oc-nav-disclosure]').forEach(other => { if (other !== details) other.open = false; });
        details.open = nextOpen; sync();
      });
      details.addEventListener('toggle', sync);
      details.addEventListener('keydown', event => { if (event.key === 'Escape') { event.stopPropagation(); details.open = false; summary.focus(); sync(); } });
      details.addEventListener('keyup', event => { if (event.key === 'Escape') event.stopPropagation(); });
      document.addEventListener('click', event => { if (!details.contains(event.target)) details.open = false; });
    });
  };
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',ready); else ready();
})();
